<template>
    <div class="app-container">
        <SkeletonHome v-if="loadingSkeletonHome"/>
        <div v-else>
            <van-row class="home-header">
                <van-col :span="10">
                    <img src="@/assets/images/logo4.jpg" class="logo">
                </van-col>
                <van-col :span="10">
                </van-col>
                <van-col :span="4">
                    <div class="kefu" @click="showContact">
                        <img src="@/assets/images/home/ico_service.png" style="width: 45%;;vertical-align: middle"
                             @click="">
                    </div>
                </van-col>
            </van-row>

            <!-- 暂时隐藏首页横幅，保留代码便于恢复
            <div class="home-swipe-class">
                <van-swipe class="home-swipe" :autoplay="5000" indicator-color="white">
                    <van-swipe-item v-for="item, idx in banners" :key="idx" @click="goUrl(item.skipUrl)">
                        <img class="home-swipe-image" :src="item.imgUrl">
                    </van-swipe-item>
                </van-swipe>
            </div>
            -->

            <van-row class="home-icon-list">
                <van-col class="homeMenuCol" v-for="(item, index) in homeMenus" :key="index"
                         @click="homeMenuClickNow(item.id)">
                    <div class="homeMenuColImg" :class="item.class" :id="item.btnId"/>
                    <span class="homeMenuColTitle">{{ item.title }}</span>
                </van-col>
            </van-row>

            <div class="content">
                <!--热门产品-->
                <div class="insuranceBox">
                    <van-row>
                        <van-col :span="12" class="box-tittle">全程产品服务</van-col>
                    </van-row>

                    <van-row>
                        <van-col span="12">
                            <van-row class="new-recommend" @click="goProductPage(1)">
                                <van-row>
                                    <van-col span="24" class="tittle tc">
                                        <span class="c-orange">国内</span>运输险
                                    </van-col>
                                </van-row>
                                <van-row>
                                    <van-col span="24" class="title-tips tc">区域全面覆盖 用户无忧</van-col>
                                </van-row>
                                <van-row style="margin: 15px 0">
                                    <img class="transport-img" src="@/assets/images/home/qiche.png">
                                </van-row>
                            </van-row>
                        </van-col>
                        <van-col span="12">
                            <van-row class="new-recommend" style="margin-left: 12px;" @click="goProductPage(2)">
                                <van-row>
                                    <van-col span="24" class="tittle">
                                        <span class="c-blue">出口</span>运输险

                                        <img src="@/assets/images/home/feiji.png" style="float: right; width: 36%;">
                                    </van-col>
                                </van-row>
                                <van-row>
                                    <van-col span="24" class="title-tips">时效保障 高额赔付</van-col>
                                </van-row>
                            </van-row>

                            <van-row class="new-recommend" style="margin-left: 12px;" @click="goProductPage(3)">
                                <van-row>
                                    <van-col span="24" class="tittle">
                                        <span class="c-blue">进口</span>运输险

                                        <img src="@/assets/images/home/lunchuan.png" style="float: right; width: 36%;">
                                    </van-col>
                                </van-row>
                                <van-row>
                                    <van-col span="24" class="title-tips">专业服务 物流无忧</van-col>
                                </van-row>
                            </van-row>
                        </van-col>
                    </van-row>
                </div>

                <!--行业咨询-->
                <div class="insuranceBox">
                    <van-row style="margin-bottom: 10px">
                        <van-col :span="12" class="box-tittle">行业咨询</van-col>
                        <van-col :span="11" class="all" @click.native="homeMenuClickNow(2)">全部
                            <van-icon name="arrow" color="#666"
                                      style="vertical-align: middle;margin:-1px -3px 0 -1px;"/>
                        </van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24">
                            <div class="advert">
                                <van-row class="advert-item" v-for="(advert,index) in adverts" :key="index"
                                         @click="goAdvertPage(advert)">
                                    <!--<van-col :span="7">-->
                                    <!--<div class="icon">-->
                                    <!--<img :src="advert.iconUrl" alt="">-->
                                    <!--</div>-->
                                    <!--</van-col>-->
                                    <!--<van-col :span="16">-->
                                    <!--<div class="title">{{ advert.title|ellipsis(80) }}</div>-->
                                    <!--<div class="describe" v-html="$util.ellipsis(advert.content, 300)"></div>-->
                                    <!--<div class="atime">{{advert.advertTime | formatTime}}</div>-->
                                    <!--</van-col>-->

                                    <div class="intr">
                                        <div class="title">{{ advert.title|ellipsis(80) }}</div>
                                        <div class="describe" v-html="$util.ellipsis(advert.content, 100)"></div>
                                        <div class="atime">{{advert.advertTime | formatTime}}</div>
                                    </div>

                                    <van-row class="item-pic"><img :src="advert.iconUrl"/>
                                    </van-row>
                                </van-row>
                            </div>
                        </van-col>
                    </van-row>
                </div>

                <div class="insuranceBox">
                    <van-row style="margin-bottom: 10px">
                        <van-col :span="12" class="box-tittle">战略合作伙伴</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24">
                            <van-row>
                                <div class="cont-lb">
                                    <van-swipe :autoplay="5000" :lazy-render="true">
                                        <van-swipe-item v-for="(itemlist, key) in partnerList" :key="key">
                                            <template v-for="(item, index) in itemlist">
                                                <div :key="index" class="img-class">
                                                    <span>{{ item.name }}</span>
                                                    <img :src="item.cover" alt>
                                                </div>
                                            </template>
                                        </van-swipe-item>
                                    </van-swipe>
                                </div>
                            </van-row>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>

        <contact-dialog :dialogShowMessage="dialogShowMessage" ref="contactDialog"></contact-dialog>
    </div>

</template>

<script>
    import { getAdvertPage, getBannerList } from "@/modules/home/core/api";
    import { productIssuePage } from "@/modules/product/core/api";
    import contactDialog from "@/core/component/contactDialog";

    export default {
        name: "product",
        components: {contactDialog},
        data () {
            return {
                loadingSkeletonHome: true,
                dialogShowMessage: {
                    image: "https://file.lianbaokeji.com/20260714/673efcc9954a4a1d826c4239968564b7.png",
                    msg: {
                        title: "客服热线",
                        value: "189 1630 3975"
                    },
                },
                homeMenus: [
                    {id: 1, btnId: 'btnGuide', class: 'icon-size icon-product', title: '精选产品', tag: '新'},
                    {id: 2, btnId: 'btnSingle', class: 'icon-size icon-consult', title: '行业资讯', tag: ''},
                    {id: 3, btnId: 'btnTG', class: 'icon-size icon-case', title: '合作案例', tag: '赚现金'},
                    {id: 4, btnId: 'btnTG', class: 'icon-size icon-about-us', title: '关于我们', tag: '赚现金'}
                ],

                banners: [],
                products: [],
                adverts: [],
                partnerList: [
                    [{
                        id: 1,
                        cover: require('@/assets/images/partners/renbao.png'),
                        title: ''
                    }, {
                        id: 2,
                        cover: require('@/assets/images/partners/pingan.png'),
                        title: ''
                    }, {
                        id: 3,
                        cover: require('@/assets/images/partners/taiping.png'),
                        title: ''
                    }], [{
                        id: 4,
                        cover: require('@/assets/images/partners/huatai.png'),
                        title: ''
                    }, {
                        id: 5,
                        cover: require('@/assets/images/partners/yangguang.png'),
                        title: ''
                    }, {
                        id: 6,
                        cover: require('@/assets/images/partners/guotai.png'),
                        title: ''
                    }], [{
                        id: 7,
                        cover: require('@/assets/images/partners/chinaTaiping.png'),
                        title: ''
                    }, {
                        id: 8,
                        cover: require('@/assets/images/partners/chinaLife.png'),
                        title: ''
                    }, {
                        id: 9,
                        cover: require('@/assets/images/partners/huatai.png'),
                        title: ''
                    }]
                ],

            };
        },
        computed: {},
        created () {

        },
        mounted () {
            this.getBannerList()
            // this.getProductList();
            this.getAdvert();
        },

        methods: {
            showContact () {
                this.$refs.contactDialog.init()
            },

            // 顶部banner
            getBannerList () {
                let queryParam = {
                    position: 1,
                    page: {
                        page: 1,
                        limit: 20
                    }
                };

                getBannerList(queryParam).then((res) => {
                    if (res.code == 0) {
                        this.banners = res.data;

                        this.$nextTick(() => {
                            this.loadingSkeletonHome = false
                        })
                    }
                }).catch((error) => {
                    console.log(error)
                });
            },

            getProductList () {
                let queryParam = {
                    entity: {
                        companyId: null,
                    },
                    page: {
                        page: 1,
                        limit: 10
                    }
                };
                productIssuePage(queryParam).then((res) => {
                    if (res.code == 0) {
                        this.products = res.data.rows;

                    } else {

                        this.noData = true;

                    }
                }).catch((error) => {
                    console.log(error)
                });
            },

            getAdvert () {
                let queryParam = {
                    entity: {},
                    page: {
                        page: 1,
                        limit: 5
                    }
                };
                getAdvertPage(queryParam).then((res) => {
                    if (res.code == 0) {
                        this.adverts = res.data.rows;
                    }
                }).catch((error) => {
                    console.log(error)
                });
            },

            homeMenuClickNow (index) {
                console.log(index)
                if (index == 1) {
                    //产品
                    this.$router.push('/product/list');
                } else if (index == 2) {
                    //个险
                    this.$router.push('/advert/list');
                } else if (index == 3) {
                    //合作案例
                    this.$router.push('/coop');
                } else if (index == 4) {
                    //关于我们
                    this.$router.push('/about');
                }
            },
            goAdvertPage (data) {
                this.$router.push("/advert/info?id=" + data.id);
            },
            goProductPage (transportCode) {
                console.log(transportCode)
                this.$router.push("/product/list?transportCode=" + transportCode);
            },
            goUrl(link) {
                this.$util.jumpLink(link);
            }
        }
    }
</script>
<style lang="scss" scoped>

    .home-header {
        padding-top: 12px;
        padding-right: 15px;
        padding-left: 15px;
        background-color: #FFFFFF;

        .logo {
            width: 100%;
        }
    }

    .home-swipe-class {
        background-color: #FFFFFF;
        /*padding-top: 12px;*/
        padding-bottom: 12px;

        //margin-right: 10px;
        //margin-left: 10px;

        ::v-deep .van-swipe__indicators {
            display: none;
        }

        .home-swipe .van-swipe-item {
            color: #fff;
            background-color: #fff;
            font-size: 20px;
            text-align: center;

            padding-left: 10px;
            padding-right: 10px;

        }

        .home-swipe-image {
            width: 100%;
            border-radius: 15px;

        }

    }

    .home-icon-list {
        color: #333;
        background: #fff;
        padding: 5px 0 0px;
        font-size: 12px;

        .homeMenuCol {
            text-align: center;
            margin-bottom: 10px;
            //display: flex;
            width: 25%;

            .homeMenuColImg {
                height: 52px;
                text-align: center;
            }

            .homeMenuColTitle {
                font-size: 14px;
                color: #333;
            }
        }
    }

    .icon-size {
        height: 26px;
        margin-bottom: -5px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
    }

    .icon-product {
        background-image: url("../../../assets/images/home/icon-product.png");
    }

    .icon-consult {
        background-image: url("../../../assets/images/home/icon-news.png");
    }

    .icon-case {
        background-image: url("../../../assets/images/home/icon_lesson.png");
    }

    .icon-about-us {
        background-image: url("../../../assets/images/home/icon_points.png");
    }

    .insuranceBox {
        //background: linear-gradient(to bottom, #fff, #f4f5f7 180px);
        padding-top: 18px;

        .box-tittle {
            font-size: 17px;
            font-weight: 600;
            margin-left: 5px;
        }
    }

    .all {
        line-height: 30px;
        text-align: right;
        font-size: 14px;
        margin-top: -4px;
        color: #333;
    }

    .new-recommend {
        background: linear-gradient(to bottom, #e0ecff, #fff 60px);
        padding: 10px 10px;
        margin-top: 15px;
        border-radius: 10px;
        box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.1);
        /*height: 240px;*/

        .tc {
            text-align: center;
        }

        .ml12 {
            margin-left: 12px;
        }

        .tittle {
            font-size: 16px;
            font-weight: 500;
            margin: 15px 0;
        }

        .title-tips {
            font-size: 12px;
            font-weight: 400;
            color: #9f9fa0;
            margin-bottom: 15px
        }

        .transport-img {
            width: 100%;
            border-radius: 15px;
        }
    }

    .cont-lb {
        ::v-deep .van-swipe__indicator {
            background: #bbc0c7;
        }

        ::v-deep .van-swipe__indicator--active {
            background: #58fa0b;
        }

        ::v-deep .van-swipe__indicators {
            display: none;
        }
    }

    .img-class {
        /*background: transparent;*/
        width: 32%;
        /*box-shadow: 0px 2px 12px rgba(100, 101, 102, 0.12);*/
        /*border-radius: 2px;*/
        /*border: 0.75px solid #EDEEEF;*/
        float: left;
        &:not(:first-child) {
            margin-left: 2%
        }
    }

    .img-class > span {
        position: absolute;
        margin-left: 10.5px;
        margin-top: 8.5px;
        font-size: 15px;
        font-weight: 600;
    }

    .img-class > img {
        width: 100%;
        border: 0.75px solid #EDEEEF;
        border-radius: 5px;
    }

    .kefu {
        text-align: right;
        margin-top: 9px;
        margin-right: 1.5px;
    }

    .c-orange {
        color: #ff6600;
    }

    .c-blue {
        color: #0f6dff;
    }

    .content {
        background: linear-gradient(to bottom, #fff, transparent 60px);
        padding-right: 12px;
        padding-left: 12px;
    }

    .advert {
        background: #fff;
        padding: 10px 10px;
        border-radius: 10px;
        box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.1);

        .advert-item {
            padding: 10px 0;

            &:not(:last-child) {
                border-bottom: 1px solid #ebeef5;
            }
            .item-pic {
                width: 80px;
                height: 80px;
                float: right;
                overflow: hidden;
                position: absolute;
                right: 25px;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 6px;
                    object-fit: cover;
                }
            }

            .intr {
                float: left;
                margin-right: 95px;
                line-height: 22px;

                .title {
                    font-size: 14px;
                    font-weight: 500;
                    position: relative;
                    padding-bottom: 5px;
                }

                .describe {
                    font-size: 13px;
                    line-height: 24px;
                    color: #999;
                    text-align: left;
                    display: -webkit-box; /* Safari */
                    -webkit-line-clamp: 1; /* Safari and Chrome */
                    -webkit-box-orient: vertical; /* Safari and Chrome */
                    overflow: hidden;
                    margin-top: 3px;
                }

                .atime {
                    color: #999;
                    margin-top: 8px;
                }
            }
        }
    }

</style>
